import {PageTitle} from '../../../_metronic/layout/core';
import {useIntl} from 'react-intl';
import TabComponent from '../../../app/common/components/TabComponent';
import Services from '../Components/Services';
import Telephonie from '../Components/Telephonie';
import Hebergement from '../Components/Hebergement';
import {useQuery} from 'react-query';
import {ListService} from '../Types/service';
import {getFilteredServices, getServicesByClient} from '../Api/api';

interface ServiceListProps {
    activeKey: string;
}

const ServiceList = ({activeKey}: ServiceListProps): JSX.Element => {
    const intl = useIntl();
    const {isLoading, data: services} = useQuery<ListService[]>(
        ['get-service-by-client'],
        async () => getServicesByClient()
    );

    const linkServices = getFilteredServices(services, 'Connexion');
    const telServices = getFilteredServices(services, 'TELEPHONY');
    const vpnServices = getFilteredServices(services, 'Hebergement');

    return (
        <>
            <PageTitle breadcrumbs={[]}>
                {intl.formatMessage({id: 'MENU.INFRASTRUCTURE'})}
            </PageTitle>
            <TabComponent
                tabData={[
                    {
                        title: 'Connexions',
                        key: 'connexion',
                        to: '/services/connexion',
                        content: <Services isLoading={isLoading} services={linkServices} />,
                    },
                    {
                        title: 'Téléphonie',
                        key: 'telephonie',
                        to: '/services/telephonie',
                        content: <Telephonie isLoading={isLoading} services={telServices} />,
                    },
                    {
                        title: 'Hébergement',
                        key: 'hebergement',
                        to: '/services/hebergement',
                        content: <Hebergement isLoading={isLoading} services={vpnServices} />,
                    },
                ]}
                activeKey={activeKey}
            />
        </>
    );
};

export default ServiceList;
